"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = createFirebaseInstance;

var _isObject2 = _interopRequireDefault(require("lodash/isObject")),
    _utils = require("./utils"),
    _actions = require("./utils/actions"),
    _actions2 = require("./actions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null == arguments[i] ? {} : arguments[i],
        ownKeys = Object.keys(source);
    "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
      return Object.getOwnPropertyDescriptor(source, sym).enumerable;
    }))), ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

function createFirebaseInstance(firebase, configs, dispatch) {
  configs.enableLogging && firebase.database && "function" == typeof firebase.database.enableLogging && firebase.database.enableLogging(configs.enableLogging);
  Object.defineProperty(firebase, "_", {
    value: {
      watchers: {},
      listeners: {},
      callbacks: {},
      queries: {},
      config: configs,
      authUid: null
    },
    writable: !0,
    enumerable: !0,
    configurable: !0
  });

  var withMeta = function withMeta(method, path, value, onComplete) {
    if ((0, _isObject2.default)(value)) {
      var prefix = "update" === method ? "updated" : "created",
          dataWithMeta = _objectSpread({}, value, _defineProperty({}, "".concat(prefix, "At"), firebase.database.ServerValue.TIMESTAMP));

      return firebase.auth().currentUser && (dataWithMeta["".concat(prefix, "By")] = firebase.auth().currentUser.uid), firebase.database().ref(path)[method](dataWithMeta, onComplete);
    }

    return firebase.database().ref(path)[method](value, onComplete);
  },
      actionCreators = (0, _actions.mapWithFirebaseAndDispatch)(firebase, dispatch, {
    signInWithPhoneNumber: _actions2.authActions.signInWithPhoneNumber
  }, {
    initializeAuth: _actions2.authActions.init
  });

  return Object.assign(firebase, _objectSpread({
    ref: function ref(path) {
      return firebase.database().ref(path);
    },
    set: function set(path, value, onComplete) {
      return firebase.database().ref(path).set(value, onComplete);
    },
    setWithMeta: function setWithMeta(path, value, onComplete) {
      return withMeta("set", path, value, onComplete);
    },
    uniqueSet: function uniqueSet(path, value, onComplete) {
      return firebase.database().ref(path).transaction(function (d) {
        return null === d ? value : void 0;
      }).then(function (_ref) {
        var committed = _ref.committed,
            snapshot = _ref.snapshot;

        if (!committed) {
          var newError = new Error("Path already exists.");
          return onComplete && onComplete(newError), Promise.reject(newError);
        }

        return onComplete && onComplete(snapshot), snapshot;
      });
    },
    push: function push(path, value, onComplete) {
      return firebase.database().ref(path).push(value, onComplete);
    },
    pushWithMeta: function pushWithMeta(path, value, onComplete) {
      return withMeta("push", path, value, onComplete);
    },
    remove: function remove(path, onComplete, options) {
      return _actions2.queryActions.remove(firebase, dispatch, path, options).then(function () {
        return "function" == typeof onComplete && onComplete(), path;
      });
    },
    update: function update(path, value, onComplete) {
      return firebase.database().ref(path).update(value, onComplete);
    },
    updateWithMeta: function updateWithMeta(path, value, onComplete) {
      return withMeta("update", path, value, onComplete);
    },
    login: function login(credentials) {
      return _actions2.authActions.login(dispatch, firebase, credentials);
    },
    handleRedirectResult: function handleRedirectResult(authData) {
      return _actions2.authActions.handleRedirectResult(dispatch, firebase, authData);
    },
    logout: function logout() {
      return _actions2.authActions.logout(dispatch, firebase);
    },
    updateAuth: function updateAuth(authUpdate, updateInProfile) {
      return _actions2.authActions.updateAuth(dispatch, firebase, authUpdate, updateInProfile);
    },
    updateEmail: function updateEmail(newEmail, updateInProfile) {
      return _actions2.authActions.updateEmail(dispatch, firebase, newEmail, updateInProfile);
    },
    updateProfile: function updateProfile(profileUpdate, options) {
      return _actions2.authActions.updateProfile(dispatch, firebase, profileUpdate, options);
    },
    uploadFile: function uploadFile(path, file, dbPath, options) {
      return _actions2.storageActions.uploadFile(dispatch, firebase, {
        path: path,
        file: file,
        dbPath: dbPath,
        options: options
      });
    },
    uploadFiles: function uploadFiles(path, files, dbPath, options) {
      return _actions2.storageActions.uploadFiles(dispatch, firebase, {
        path: path,
        files: files,
        dbPath: dbPath,
        options: options
      });
    },
    deleteFile: function deleteFile(path, dbPath) {
      return _actions2.storageActions.deleteFile(dispatch, firebase, {
        path: path,
        dbPath: dbPath
      });
    },
    createUser: function createUser(credentials, profile) {
      return _actions2.authActions.createUser(dispatch, firebase, credentials, profile);
    },
    resetPassword: function resetPassword(credentials) {
      return _actions2.authActions.resetPassword(dispatch, firebase, credentials);
    },
    confirmPasswordReset: function confirmPasswordReset(code, password) {
      return _actions2.authActions.confirmPasswordReset(dispatch, firebase, code, password);
    },
    verifyPasswordResetCode: function verifyPasswordResetCode(code) {
      return _actions2.authActions.verifyPasswordResetCode(dispatch, firebase, code);
    },
    watchEvent: function watchEvent(type, path, storeAs) {
      var options = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : {};
      return _actions2.queryActions.watchEvent(firebase, dispatch, _objectSpread({
        type: type,
        path: path,
        storeAs: storeAs
      }, options));
    },
    unWatchEvent: function unWatchEvent(type, path, queryId) {
      var options = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : {};
      return _actions2.queryActions.unWatchEvent(firebase, dispatch, _objectSpread({
        type: type,
        path: path,
        queryId: queryId
      }, options));
    },
    reloadAuth: function reloadAuth() {
      return _actions2.authActions.reloadAuth(dispatch, firebase);
    },
    linkWithCredential: function linkWithCredential(credential) {
      return _actions2.authActions.linkWithCredential(dispatch, firebase, credential);
    },
    promiseEvents: function promiseEvents(watchArray, options) {
      var inputAsFunc = (0, _utils.createCallable)(watchArray),
          prevData = inputAsFunc(options, firebase),
          queryConfigs = (0, _utils.getEventsFromInput)(prevData);
      return Promise.all(queryConfigs.map(function (queryConfig) {
        return _actions2.queryActions.watchEvent(firebase, dispatch, queryConfig);
      }));
    },
    dispatch: dispatch
  }, actionCreators));
}

module.exports = exports.default;